import { defineMessages } from 'react-intl';

export default defineMessages({
  printLabel: {
    defaultMessage: 'Print Label',
    description: 'Text for a button that will print a shipping label that has already been created',
    id: 'X3WmXH',
  },
  voidLabel: {
    defaultMessage: 'Void Label',
    description: 'Text for a button that will void a shipping label that has already been created',
    id: 'Z4R7/L',
  },
  copyTracking: {
    defaultMessage: 'Copy Tracking Number',
    id: 'JBZxBi',
    description: 'label for a button that copies the tracking number of a shipment',
  },
  undoMarkAsShipped: {
    defaultMessage: 'Undo Mark as Shipped',
    id: '0YCPe3',
    description: 'label for a button that undoes a previous user action wherein the user marked an order as "shipped"',
  },
  markAsReceived: {
    description: 'returnDetailsOtherActions.markAsReceived',
    defaultMessage: 'Mark As Received',
    id: 'UOUeps',
  },
  sendReturnLabel: {
    description: 'returnDetailsOtherActions.sendReturnLabel',
    defaultMessage: 'Send Return Label',
    id: 'TS48Ew',
  },
});
